import { StyleUtil } from 'utils/StyleUtil'
import closeSvg from '../images/close2.svg'
import Spinner from './Spinner'
import React from 'react'

interface Props {
  id: string
  title: string
  subtitle?: string
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
  onClose: () => void
}

export default function WidgetConfirmation({
  id,
  title,
  subtitle,
  isLoading,
  onConfirm,
  onCancel,
  onClose,
}: Props): JSX.Element {
  return (
    <div
      id={id}
      className="absolute z-[999] flex h-full w-full flex-col items-center justify-center bg-[#D5D5DBAA]"
    >
      <div className="flex h-auto flex-col gap-[8px] rounded-[12px] bg-white p-[12px] pb-[24px] shadow-xl">
        <img
          src={closeSvg}
          className="cursor-pointer self-end"
          alt="close"
          onClick={onClose}
        />
        <p className="mentem-widget-title pl-[12px] pr-[48px]">
          {title.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>
        {subtitle && (
          <p className="mentem-widget-subtitle pl-[12px] pr-[48px]">
            {subtitle}
          </p>
        )}
        <div className="flex flex-row items-center justify-center gap-4 pt-[16px]">
          {isLoading && <Spinner />}
          {!isLoading && (
            <>
              <button
                type="button"
                className={StyleUtil.buttonSecondaryUnsw}
                onClick={onConfirm}
              >
                Confirm
              </button>
              <button
                type="button"
                className={StyleUtil.buttonPrimaryUnsw}
                onClick={onCancel}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
